jQuery(document).ready(function($) {
  // Mobile navi
  $('button.hamburger').click(function() {
    $(this).find('span#nav-icon').toggleClass('open');
    $(this).toggleClass('open');
    $('body').toggleClass('navi-open');
    if ( $('body.navi-open').length > 0 ) {
      $('nav.main-navi').slideDown(300);
      $(this).attr('aria-expanded', 'true');
    }
    else {
      $('nav.main-navi').hide();
      $(this).attr('aria-expanded', 'false');
    }
  });

  if ( $(window).width() <= 1024 ) {
    $('li.menu-item-has-children > a').click(function(e) {
      if ( !$(this).hasClass('open') ) {
        e.preventDefault();
        $(this).addClass('open');
        $(this).parent().find('ul').show();
      }
      else {
        $(this).removeClass('open');
      }
    });
  }

  // Avautuva sisältö

  /* $('a.accordion-title').click(function(e) {
    e.preventDefault();
    var elm = $(this).next();
    $('div.accordion-content-wrap').not(elm).slideUp();
    $('a.accordion-title').not(this).removeClass('open');
    $(this).toggleClass('open');
    elm.slideToggle();
  }); */

  // Galleria

  var galleryLinks = document.querySelectorAll('.gallery a');
  if (galleryLinks.length > 0) {

    var numLinks = galleryLinks.length;
    var currentLink = 0;

    // Create the modal
    var modal = document.createElement('div');
    modal.classList.add('modal');
    modal.innerHTML = `
      <img class="modal-image" />
      <div class="modal-title"></div>
      <a class="modal-download" href="" download>Lataa kuva</a>
      <div class="modal-counter"></div>
      <div class="modal-prev">&#10094;</div>
      <div class="modal-next">&#10095;</div>
    `;
    document.body.appendChild(modal);

    var modalImage = modal.querySelector('.modal-image');
    var modalTitle = modal.querySelector('.modal-title');
    var modalDownload = modal.querySelector('.modal-download');
    var modalCounter = modal.querySelector('.modal-counter');
    var modalPrev = modal.querySelector('.modal-prev');
    var modalNext = modal.querySelector('.modal-next');

    // Show the modal when a link is clicked
    galleryLinks.forEach(function(link, index) {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        currentLink = index;
        showModal(currentLink);
      });
    });

    // Show the modal with the current image
    function showModal(index) {
      var href = galleryLinks[index].getAttribute('href');
      var title = galleryLinks[index].getAttribute('title');
      var counter = (index + 1) + '/' + numLinks;
      modalImage.setAttribute('src', href);
      modalTitle.textContent = title;
      modalDownload.setAttribute('href', href);
      modalCounter.textContent = counter;
      modal.style.display = 'block';
    }

    // Hide the modal when the background is clicked
    modal.addEventListener('click', function(event) {
      if (event.target === modal) {
        modal.style.display = 'none';
      }
    });

    // Show the previous image
    modalPrev.addEventListener('click', function() {
      currentLink--;
      if (currentLink < 0) {
        currentLink = numLinks - 1;
      }
      showModal(currentLink);
    });

    // Show the next image
    modalNext.addEventListener('click', function() {
      currentLink++;
      if (currentLink >= numLinks) {
        currentLink = 0;
      }
      showModal(currentLink);
    });

    // Keyboard navigation
    document.addEventListener('keydown', function(event) {
      if (event.key === 'ArrowLeft') {
        currentLink--;
        if (currentLink < 0) {
          currentLink = numLinks - 1;
        }
        showModal(currentLink);
      } else if (event.key === 'ArrowRight') {
        currentLink++;
        if (currentLink >= numLinks) {
          currentLink = 0;
        }
        showModal(currentLink);
      } else if (event.key === 'Escape') {
        modal.style.display = 'none';
      }
    });

    // Pop-up functionality
    var popUpSection = document.querySelector('section.pop-up');
    if (popUpSection) {
      var popUpItems = document.querySelectorAll('.pop-up-item');
      popUpItems.forEach(function(item) {
        item.addEventListener('click', function(e) {
          e.preventDefault();
          var popupContent = item.querySelector('.pop-up-content').cloneNode(true);
          var popupBg = document.createElement('div');
          popupBg.classList.add('popup-bg');
          document.body.appendChild(popupBg);
          document.body.appendChild(popupContent);
          var closeBtn = document.createElement('a');
          closeBtn.setAttribute('href', '#');
          closeBtn.classList.add('close');
          closeBtn.textContent = 'Sulje';
          popupContent.appendChild(closeBtn);
          popupContent.style.top = (window.scrollY + window.innerHeight * 0.1) + 'px';
          popupBg.style.display = 'block';
          popupContent.style.display = 'block';

          // Close pop-up
          popupBg.addEventListener('click', closePopup);
          closeBtn.addEventListener('click', closePopup);
        });
      });

      function closePopup(e) {
        e.preventDefault();
        var popupBg = document.querySelector('.popup-bg');
        var popupContent = document.querySelector('body > .pop-up-content');
        if (popupBg) popupBg.remove();
        if (popupContent) popupContent.remove();
      }
    }
  }

  // Galleria END

}); // jQuery(document).ready

// Kohdekaruselli
document.addEventListener('DOMContentLoaded', function () {
  const carousels = document.querySelectorAll('.kohdekaruselli-wrap');
  const swipeMedia = window.matchMedia('(max-width: 1024px)');

  carousels.forEach(function (carousel) {
    const track = carousel.querySelector('.kohdekaruselli-track');
    const items = carousel.querySelectorAll('.kohdekaruselli-item');
    const prev = carousel.querySelector('.kohdekaruselli-arrow.prev');
    const next = carousel.querySelector('.kohdekaruselli-arrow.next');

    if (!track || !items.length || !prev || !next) {
      return;
    }

    let current = 0;
    let currentOffset = 0;
    let startX = 0;
    let startY = 0;
    let dragX = 0;
    let isDragging = false;
    let isHorizontalSwipe = false;
    let suppressClick = false;

    function getCarouselOffset() {
      const activeItem = items[current];
      const carouselCenter = carousel.offsetWidth / 2;
      const itemCenter = activeItem.offsetLeft + activeItem.offsetWidth / 2;

      return carouselCenter - itemCenter;
    }

    function updateCarousel() {
      currentOffset = getCarouselOffset();

      track.style.transform = `translateX(${currentOffset}px)`;

      items.forEach(function (item, index) {
        item.classList.toggle('active', index === current);
      });

      prev.disabled = current === 0;
      next.disabled = current === items.length - 1;
    }

    function goToPrevious() {
      if (current > 0) {
        current--;
        updateCarousel();
      }
    }

    function goToNext() {
      if (current < items.length - 1) {
        current++;
        updateCarousel();
      }
    }

    function startDrag(event) {
      if (!swipeMedia.matches) {
        return;
      }

      if (
        event.pointerType === 'mouse' &&
        event.button !== 0
      ) {
        return;
      }

      startX = event.clientX;
      startY = event.clientY;
      dragX = 0;
      isDragging = true;
      isHorizontalSwipe = false;
      suppressClick = false;

      carousel.classList.add('is-dragging');

      if (carousel.setPointerCapture) {
        carousel.setPointerCapture(event.pointerId);
      }
    }

    function moveDrag(event) {
      if (!isDragging || !swipeMedia.matches) {
        return;
      }

      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;

      /*
       * Päätetään vasta pienen liikkeen jälkeen,
       * onko ele vaaka- vai pystysuuntainen.
       */
      if (!isHorizontalSwipe) {
        if (
          Math.abs(deltaX) < 8 &&
          Math.abs(deltaY) < 8
        ) {
          return;
        }

        if (Math.abs(deltaY) > Math.abs(deltaX)) {
          endDrag(event);
          return;
        }

        isHorizontalSwipe = true;
      }

      dragX = deltaX;

      /*
       * Ensimmäisen ja viimeisen kohteen yli vetämiseen
       * lisätään hieman vastusta.
       */
      if (
        (current === 0 && dragX > 0) ||
        (current === items.length - 1 && dragX < 0)
      ) {
        dragX *= 0.3;
      }

      track.style.transform =
        `translateX(${currentOffset + dragX}px)`;

      suppressClick = Math.abs(dragX) > 10;
      event.preventDefault();
    }

    function endDrag(event) {
      if (!isDragging) {
        return;
      }

      isDragging = false;
      carousel.classList.remove('is-dragging');

      if (
        event &&
        carousel.releasePointerCapture &&
        carousel.hasPointerCapture(event.pointerId)
      ) {
        carousel.releasePointerCapture(event.pointerId);
      }

      if (!isHorizontalSwipe) {
        updateCarousel();
        return;
      }

      const activeWidth = items[current].offsetWidth;
      const threshold = Math.min(activeWidth * 0.16, 100);

      if (dragX <= -threshold) {
        goToNext();
      } else if (dragX >= threshold) {
        goToPrevious();
      } else {
        updateCarousel();
      }

      window.setTimeout(function () {
        suppressClick = false;
      }, 50);
    }

    prev.addEventListener('click', function () {
      goToPrevious();
    });

    next.addEventListener('click', function () {
      goToNext();
    });

    carousel.addEventListener('pointerdown', startDrag);
    carousel.addEventListener('pointermove', moveDrag);
    carousel.addEventListener('pointerup', endDrag);
    carousel.addEventListener('pointercancel', endDrag);
    carousel.addEventListener('lostpointercapture', endDrag);

    /*
     * Estetään linkin avautuminen, jos käyttäjä
     * oikeasti swaippasi eikä klikannut.
     */
    carousel.addEventListener(
      'click',
      function (event) {
        if (suppressClick) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    window.addEventListener('resize', function () {
      isDragging = false;
      carousel.classList.remove('is-dragging');
      updateCarousel();
    });

    updateCarousel();
  });
});
// /Kohdekaruselli

// Ajankohtaista etusivu
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.load-more-news');

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      const section = button.closest('.ajankohtaista-etusivu');
      const list = section.querySelector('.news-list');

      let page = parseInt(list.dataset.page, 10);
      const maxPages = parseInt(list.dataset.maxPages, 10);

      page++;

      button.classList.add('loading');
      button.disabled = true;

      const data = new FormData();
      data.append('action', 'load_more_news');
      data.append('page', page);

      fetch(theme_ajax.ajaxurl, {
        method: 'POST',
        body: data
      })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          const temp = document.createElement('div');
          temp.innerHTML = html;

          const items = temp.querySelectorAll('.news-card');

          items.forEach(function (item, index) {
            item.classList.add('is-new');
            list.appendChild(item);

            setTimeout(function () {
              item.classList.add('visible');
            }, index * 120);
          });

          list.dataset.page = page;

          if (page >= maxPages) {
            button.closest('.load-more-wrap').remove();
          } else {
            button.classList.remove('loading');
            button.disabled = false;
          }
        });
    });
  });
});

// Hero-kuvakaruselli
document.addEventListener('DOMContentLoaded', function () {
  const heroes = document.querySelectorAll('section.hero');
  heroes.forEach(function (hero) {
    const images = hero.querySelectorAll('.hero-images img');
    const dots = hero.querySelectorAll('.hero-dots button');
    if (images.length < 2) {
      return;
    }
    let current = 0;
    let interval;
    function showImage(index) {
      current = index;
      images.forEach(function (image, imageIndex) {
        image.classList.toggle('active', imageIndex === current);
      });
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('active', dotIndex === current);
      });
    }
    function nextImage() {
      let next = current + 1;
      if (next >= images.length) {
        next = 0;
      }
      showImage(next);
    }
    function startAutoplay() {
      interval = setInterval(nextImage, 5000);
    }
    function restartAutoplay() {
      clearInterval(interval);
      startAutoplay();
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const index = parseInt(dot.dataset.index, 10);
        showImage(index);
        restartAutoplay();
      });
    });
    startAutoplay();
  });
});

// Sticky header
(function () {
  const win = window;
  const body = document.body;
  let ticking = false;
  const stickyOffset = 95;
  function onScroll() {
    const scrollTop = win.pageYOffset || document.documentElement.scrollTop;
    const isSticky = scrollTop > stickyOffset;
    if (isSticky !== body.classList.contains('sticky-header')) {
      body.classList.toggle('sticky-header', isSticky);
    }
    ticking = false;
  }
  win.addEventListener('scroll', function () {
    if (!ticking) {
      win.requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });
})();

// Kohteet-filtteröinti
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('section.kohteet');

  sections.forEach(function (section) {
    const locationSelect = section.querySelector('#kohteet-location');
    const statusButtons = section.querySelectorAll('.status-filters button');
    const cards = section.querySelectorAll('.kohde-card');
    const noResults = section.querySelector('.no-results');

    let activeStatus = 'all';

    function filterCards() {
      const activeLocation = locationSelect ? locationSelect.value : 'all';
      let visibleCount = 0;

      cards.forEach(function (card) {
        const cardLocation = card.dataset.location;
        const cardStatuses = card.dataset.status || '';

        const locationMatches = activeLocation === 'all' || cardLocation === activeLocation;
        const statusMatches = activeStatus === 'all' || cardStatuses.includes(activeStatus);

        if (locationMatches && statusMatches) {
          card.classList.remove('is-hidden');
          card.classList.remove('is-visible');

          requestAnimationFrame(function () {
            card.classList.add('is-visible');
          });

          visibleCount++;
        } else {
          card.classList.add('is-hidden');
          card.classList.remove('is-visible');
        }
      });

      if (noResults) {
        noResults.hidden = visibleCount > 0;
      }
    }

    if (locationSelect) {
      locationSelect.addEventListener('change', filterCards);
    }

    statusButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const status = button.dataset.status;

        if (activeStatus === status) {
          activeStatus = 'all';
          button.classList.remove('active');
        } else {
          activeStatus = status;

          statusButtons.forEach(function (item) {
            item.classList.remove('active');
          });

          button.classList.add('active');
        }

        filterCards();
      });
    });

    filterCards();
  });
});
// /Kohteet-filtteröinti

// Historia
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('section.historia');

  sections.forEach(function (section) {
    const track = section.querySelector('.history-track');
    const items = section.querySelectorAll('.history-item');
    const prev = section.querySelector('.history-arrow-prev');
    const next = section.querySelector('.history-arrow-next');

    if (!track || items.length < 1 || !prev || !next) {
      return;
    }

    let current = 0;

    function updateHistory() {
      const firstItem = items[0];
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const offset = current * (firstItem.offsetWidth + gap);

      track.style.transform = `translateX(-${offset}px)`;

      items.forEach(function (item, index) {
        item.classList.toggle('active', index === current);
      });

      prev.disabled = current === 0;
      next.disabled = current === items.length - 1;
    }

    prev.addEventListener('click', function () {
      if (current > 0) {
        current--;
        updateHistory();
      }
    });

    next.addEventListener('click', function () {
      if (current < items.length - 1) {
        current++;
        updateHistory();
      }
    });

    window.addEventListener('resize', updateHistory);

    updateHistory();
  });
});
// /Historia

// Avautuva sisältö
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('section.avautuva-sisalto');

  sections.forEach(function (section) {
    const buttons = section.querySelectorAll('.accordion-title');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        const item = button.closest('.accordion-item');
        const content = item.querySelector('.accordion-content-wrap');
        const isOpen = button.getAttribute('aria-expanded') === 'true';

        buttons.forEach(function (otherButton) {
          const otherItem = otherButton.closest('.accordion-item');
          const otherContent = otherItem.querySelector('.accordion-content-wrap');

          if (otherButton !== button) {
            otherButton.setAttribute('aria-expanded', 'false');
            jQuery(otherContent).stop(true, true).slideUp(300);
          }
        });

        if (isOpen) {
          button.setAttribute('aria-expanded', 'false');
          jQuery(content).stop(true, true).slideUp(300);
        } else {
          button.setAttribute('aria-expanded', 'true');
          jQuery(content).stop(true, true).slideDown(300);
        }
      });
    });
  });
});
// /Avautuva sisältö

// Yhteystiedot
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('section.yhteystiedot');

  sections.forEach(function (section) {
    const buttons = section.querySelectorAll('.contact-accordion-title');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        const item = button.closest('.contact-accordion-item');
        const content = item.querySelector('.contact-accordion-content-wrap');
        const isOpen = button.getAttribute('aria-expanded') === 'true';

        buttons.forEach(function (otherButton) {
          const otherItem = otherButton.closest('.contact-accordion-item');
          const otherContent = otherItem.querySelector('.contact-accordion-content-wrap');

          if (otherButton !== button) {
            otherButton.setAttribute('aria-expanded', 'false');
            jQuery(otherContent).stop(true, true).slideUp(300);
          }
        });

        if (isOpen) {
          button.setAttribute('aria-expanded', 'false');
          jQuery(content).stop(true, true).slideUp(300);
        } else {
          button.setAttribute('aria-expanded', 'true');
          jQuery(content).stop(true, true).slideDown(300);
        }
      });
    });
  });
});
// /Yhteystiedot

// Lightbox kuville
document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('a.js-lightbox');

  if (!links.length) {
    return;
  }

  const lightbox = document.createElement('div');
  lightbox.className = 'lightbox';
  lightbox.innerHTML = `
    <button class="lightbox-close" type="button" aria-label="Sulje">×</button>
    <img src="" alt="">
  `;

  document.body.appendChild(lightbox);

  const lightboxImage = lightbox.querySelector('img');
  const closeButton = lightbox.querySelector('.lightbox-close');

  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();

      const image = link.querySelector('img');

      lightboxImage.src = link.href;
      lightboxImage.alt = image ? image.alt : '';

      lightbox.classList.add('open');
    });
  });

  function closeLightbox() {
    lightbox.classList.remove('open');
    lightboxImage.src = '';
  }

  closeButton.addEventListener('click', closeLightbox);

  lightbox.addEventListener('click', function (event) {
    if (event.target === lightbox) {
      closeLightbox();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && lightbox.classList.contains('open')) {
      closeLightbox();
    }
  });
});
// /Lightbox kuville

// Kohde galleria
document.addEventListener('DOMContentLoaded', function () {
  const galleries = document.querySelectorAll('section.kohde-gallery');

  galleries.forEach(function (gallery) {
    const mainSlides = gallery.querySelectorAll('.gallery-main-slide');
    const mainImages = gallery.querySelectorAll('.gallery-main-slide img');
    const thumbs = gallery.querySelectorAll('.gallery-thumb');
    const prev = gallery.querySelector('.gallery-arrow-prev');
    const next = gallery.querySelector('.gallery-arrow-next');
    const playButton = gallery.querySelector('.gallery-play');
    const video = gallery.querySelector('.gallery-video');

    if (
      mainSlides.length < 2 ||
      mainImages.length < 2 ||
      !thumbs.length
    ) {
      return;
    }

    let current = 0;
    let activeSlide = 0;
    let isAnimating = false;

    function stopVideo() {
      if (!video) {
        return;
      }

      video.pause();
      video.removeAttribute('src');
      video.load();
      video.hidden = true;
    }

    function updateControls() {
      thumbs.forEach(function (thumb, index) {
        thumb.classList.toggle('active', index === current);
      });

      if (prev) {
        prev.disabled = current === 0;
      }

      if (next) {
        next.disabled = current === thumbs.length - 1;
      }
    }

    function updateMediaControls(thumb) {
      if (!playButton) {
        return;
      }

      if (
        thumb.dataset.type === 'video' &&
        thumb.dataset.video
      ) {
        playButton.hidden = false;
        playButton.dataset.video = thumb.dataset.video;
      } else {
        playButton.hidden = true;
        playButton.removeAttribute('data-video');
      }
    }

    function updateGallery(index) {
      const thumb = thumbs[index];

      if (!thumb || index === current || isAnimating) {
        return;
      }

      isAnimating = true;
      stopVideo();

      current = index;

      const nextSlide = activeSlide === 0 ? 1 : 0;
      const oldSlide = mainSlides[activeSlide];
      const newSlide = mainSlides[nextSlide];
      const newImage = mainImages[nextSlide];

      newImage.src = thumb.dataset.large;
      newImage.alt = thumb.dataset.alt || '';

      newSlide.classList.add('active');
      oldSlide.classList.remove('active');

      activeSlide = nextSlide;

      updateMediaControls(thumb);
      updateControls();

      window.setTimeout(function () {
        isAnimating = false;
      }, 950);
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        updateGallery(index);
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        if (current > 0) {
          updateGallery(current - 1);
        }
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        if (current < thumbs.length - 1) {
          updateGallery(current + 1);
        }
      });
    }

    if (playButton && video) {
      playButton.addEventListener('click', function () {
        const videoUrl = playButton.dataset.video;

        if (!videoUrl) {
          return;
        }

        video.src = videoUrl;
        video.hidden = false;
        playButton.hidden = true;

        const playPromise = video.play();

        if (playPromise !== undefined) {
          playPromise.catch(function () {
            video.controls = true;
          });
        }
      });

      video.addEventListener('ended', function () {
        video.hidden = true;
        video.pause();
        video.removeAttribute('src');
        video.load();

        const activeThumb = thumbs[current];

        if (
          activeThumb &&
          activeThumb.dataset.type === 'video'
        ) {
          playButton.hidden = false;
        }
      });
    }

    updateMediaControls(thumbs[0]);
    updateControls();
  });
});
// /Kohde galleria

// Kohde asunnot
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('section.kohde-apartments');

  sections.forEach(function (section) {
    const rows = section.querySelectorAll('.apartment-row');

    rows.forEach(function (row) {
      row.addEventListener('click', function () {
        const item = row.closest('.apartment-item');
        const content = item.querySelector('.apartment-content-wrap');
        const isOpen = row.getAttribute('aria-expanded') === 'true';

        rows.forEach(function (otherRow) {
          const otherItem = otherRow.closest('.apartment-item');
          const otherContent = otherItem.querySelector('.apartment-content-wrap');

          if (otherRow !== row) {
            otherRow.setAttribute('aria-expanded', 'false');
            jQuery(otherContent).stop(true, true).slideUp(300);
          }
        });

        if (isOpen) {
          row.setAttribute('aria-expanded', 'false');
          jQuery(content).stop(true, true).slideUp(300);
        } else {
          row.setAttribute('aria-expanded', 'true');
          jQuery(content).stop(true, true).slideDown(300);
        }
      });
    });
  });
});
// /Kohde asunnot

// Kohde perustiedot
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('section.kohde-basic-info');

  sections.forEach(function (section) {
    const buttons = section.querySelectorAll('.basic-accordion-title');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        const item = button.closest('.basic-accordion-item');
        const content = item.querySelector('.basic-accordion-content-wrap');
        const isOpen = button.getAttribute('aria-expanded') === 'true';

        buttons.forEach(function (otherButton) {
          const otherItem = otherButton.closest('.basic-accordion-item');
          const otherContent = otherItem.querySelector('.basic-accordion-content-wrap');

          if (otherButton !== button) {
            otherButton.setAttribute('aria-expanded', 'false');
            jQuery(otherContent).stop(true, true).slideUp(300);
          }
        });

        if (isOpen) {
          button.setAttribute('aria-expanded', 'false');
          jQuery(content).stop(true, true).slideUp(300);
        } else {
          button.setAttribute('aria-expanded', 'true');
          jQuery(content).stop(true, true).slideDown(300);
        }
      });
    });
  });
});
// /Kohde perustiedot

// Pehmeä scrollaus ankkureihin (sticky header 95 px)
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');
      // Ohitetaan tyhjät ankkurit
      if (targetId === '#') {
        return;
      }
      const target = document.querySelector(targetId);
      if (!target) {
        return;
      }
      e.preventDefault();
      const headerHeight = 95;
      const targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
      });
    });
  });
});
// /Pehmeä scrollaus ankkureihin (sticky header 95 px)

// Tervo lukuina animaatio
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('section.tervo-lukuina');

  if (!sections.length) {
    return;
  }

  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  function parseCounter(element) {
    const originalValue = element.textContent.trim();

    // Etsitään ensimmäinen kokonais- tai desimaaliluku.
    const match = originalValue.match(/\d+(?:[.,]\d+)?/);

    if (!match) {
      return null;
    }

    const numberString = match[0];
    const numberPosition = match.index;
    const decimalSeparator = numberString.includes(',') ? ',' : '.';
    const decimalParts = numberString.split(/[.,]/);

    return {
      decimals: decimalParts[1] ? decimalParts[1].length : 0,
      decimalSeparator: decimalSeparator,
      prefix: originalValue.substring(0, numberPosition),
      suffix: originalValue.substring(
        numberPosition + numberString.length
      ),
      target: parseFloat(numberString.replace(',', '.')),
    };
  }

  function formatCounterValue(value, counterData) {
    let formattedValue;

    if (counterData.decimals > 0) {
      formattedValue = value.toFixed(counterData.decimals);

      if (counterData.decimalSeparator === ',') {
        formattedValue = formattedValue.replace('.', ',');
      }
    } else {
      formattedValue = Math.round(value).toString();
    }

    return (
      counterData.prefix +
      formattedValue +
      counterData.suffix
    );
  }

  function animateCounter(element, delay) {
    const counterData = parseCounter(element);

    if (!counterData) {
      return;
    }

    if (reduceMotion) {
      element.textContent = formatCounterValue(
        counterData.target,
        counterData
      );
      return;
    }

    const duration = 2200;
    let startTime = null;

    element.textContent = formatCounterValue(0, counterData);

    function animationStep(timestamp) {
      if (!startTime) {
        startTime = timestamp;
      }

      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Rauhallisesti hidastuva liike.
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      const currentValue = counterData.target * easedProgress;

      element.textContent = formatCounterValue(
        currentValue,
        counterData
      );

      if (progress < 1) {
        window.requestAnimationFrame(animationStep);
      } else {
        element.textContent = formatCounterValue(
          counterData.target,
          counterData
        );
      }
    }

    window.setTimeout(function () {
      window.requestAnimationFrame(animationStep);
    }, delay);
  }

  const observer = new IntersectionObserver(
    function (entries, currentObserver) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        const counters = entry.target.querySelectorAll(
          '.js-count-up'
        );

        counters.forEach(function (counter, index) {
          animateCounter(counter, index * 120);
        });

        currentObserver.unobserve(entry.target);
      });
    },
    {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.25,
    }
  );

  sections.forEach(function (section) {
    observer.observe(section);
  });
});
// /Tervo lukuina animaatio

// Ajankohtaista etusivu: korttien ilmestyminen
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll(
    'section.ajankohtaista-etusivu'
  );

  if (!sections.length) {
    return;
  }

  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  sections.forEach(function (section) {
    const cards = section.querySelectorAll(
      '.news-list > .news-card'
    );

    if (!cards.length) {
      return;
    }

    cards.forEach(function (card) {
      card.classList.add('reveal-item');
    });

    if (reduceMotion) {
      cards.forEach(function (card) {
        card.classList.add('visible');
      });

      return;
    }

    const observer = new IntersectionObserver(
      function (entries, currentObserver) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }

          cards.forEach(function (card, index) {
            window.setTimeout(function () {
              card.classList.add('visible');
            }, 300 + (index * 500));
          });

          currentObserver.unobserve(section);
        });
      },
      {
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.2,
      }
    );

    observer.observe(section);
  });
});
// /Ajankohtaista etusivu: korttien ilmestyminen

// Footerin yläpuolisen taustakuvan ilmestyminen
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll(
    'section.yksi-palsta.some'
  );

  if (!sections.length) {
    return;
  }

  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  sections.forEach(function (section) {
    if (reduceMotion) {
      section.classList.add('background-visible');
      return;
    }

    const observer = new IntersectionObserver(
      function (entries, currentObserver) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }

          window.setTimeout(function () {
            section.classList.add('background-visible');
          }, 250);

          currentObserver.unobserve(section);
        });
      },
      {
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.2,
      }
    );

    observer.observe(section);
  });
});
// /Footerin yläpuolisen taustakuvan ilmestyminen